import React, { useEffect, useState } from "react";
import cvData from "../data/cvData.json";

const Header = () => {
  const { name, title } = cvData.personalInfo;
  const linkedinUrl =
    cvData.socialMedia?.find(
      (social) =>
        social.name?.toLowerCase() === "linkedin"
    )?.url
  const [isHeaderShrunk, setIsHeaderShrunk] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  function throttle(func, delay) {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (Date.now() - lastRan >= delay) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, delay - (Date.now() - lastRan));
      }
    };
  }

  useEffect(() => {
    const handleScroll = throttle(() => {
      if (window.scrollY > 50) {
        setIsHeaderShrunk(true);
      } else {
        setIsHeaderShrunk(false);
      }
    }, 10);

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div
      className={`w-full ${isHeaderShrunk ? "h-20" : "h-28 md:h-32"}`}
    >
      <header
        className={`glass-panel fixed left-0 right-0 top-0 z-50 flex items-center rounded-none border-x-0 border-t-0 px-6 transition-all ease-in-out duration-300 ${isHeaderShrunk ? "h-20" : "h-28 md:h-32"
          }`}
      >
        <div className="mx-auto flex w-full max-w-6xl items-center gap-4">
          <div className="transition-all ease-in-out duration-300">
            <img
              src="/assets/images/profile-160.jpg"
              alt={`Deklerk Basson - Senior Software Engineer - Portrait`}
              width="160"
              height="160"
              loading="eager"
              decoding="async"
              fetchpriority="high"
              srcSet="/assets/images/profile-80.jpg 80w, /assets/images/profile-160.jpg 160w"
              sizes="(min-width: 768px) 80px, 64px"
              className={`rounded-full object-cover ring-2 ring-white/40 shadow-[0_16px_35px_-20px_rgba(15,23,42,0.9)] transition-all ease-in-out duration-300 ${isHeaderShrunk ? "h-10 w-10" : "h-16 w-16 md:h-20 md:w-20"
                }`}
            />
          </div>

          <div className="flex flex-1 flex-col items-start gap-2">
            <div>
              <h1 className="font-display text-2xl font-semibold tracking-tight text-white md:text-4xl">
                {name}
              </h1>
              <p
                className={`text-sm text-text-secondary ${isHeaderShrunk ? "text-xs" : "text-sm"
                  }`}
              >
                {title}
              </p>
            </div>
            {!isHeaderShrunk && (
              <a
                href={linkedinUrl}
                target="_blank"
                rel="me noopener noreferrer"
                className="glass-button"
                aria-label="Deklerk Basson on LinkedIn"
              >
                LinkedIn
              </a>
            )}
          </div>

          <div className="ml-auto flex lg:hidden">
            <button
              type="button"
              className="glass-nav-item"
              aria-expanded={isMobileMenuOpen}
              aria-controls="mobile-nav"
              onClick={() => setIsMobileMenuOpen((prev) => !prev)}
            >
              {isMobileMenuOpen ? "Close" : "Menu"}
            </button>
          </div>
        </div>
      </header>

      {isMobileMenuOpen && (
        <nav
          id="mobile-nav"
          className="glass-nav-panel glass-pop fixed right-6 top-[7.5rem] z-40 flex w-48 flex-col gap-2 p-3 lg:hidden"
          aria-label="Mobile navigation"
        >
          <a className="glass-nav-item" href="#about" onClick={handleNavClick}>About</a>
          <a className="glass-nav-item" href="#experience" onClick={handleNavClick}>Experience</a>
          <a className="glass-nav-item" href="#skills" onClick={handleNavClick}>Skills</a>
          <a className="glass-nav-item" href="#ideal-next-job" onClick={handleNavClick}>Next Job</a>
          <a className="glass-nav-item" href="#education" onClick={handleNavClick}>Education</a>
          <a className="glass-nav-item" href="#projects" onClick={handleNavClick}>Projects</a>
          <a className="glass-nav-item" href="#hobbies" onClick={handleNavClick}>Hobbies</a>
          <a className="glass-nav-item" href="#soft-skills" onClick={handleNavClick}>Soft Skills</a>
          <a className="glass-nav-item" href="#contact" onClick={handleNavClick}>Contact</a>
        </nav>
      )}
    </div>
  );
};

export default Header;
